module.exports = __webpack_public_path__ + "img/tp2.7407dc8e.png";